import { Pipe, PipeTransform } from '@angular/core';

const card_types = {
  'V': 'pojazd',
  'D': 'kierowca',
  'C': 'pojazd/kierowca',
  'B': 'okaziciel'
};

@Pipe({
  name: 'cardTypeDict'
})
export class CardTypeDictPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return card_types[value] || '-';
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pipes/card-type-dict.pipe.ts